/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneHighlightedArticles as ResolvedStandaloneHighlightedArticles } from 'base/components/standalone/HighlightedArticles';

export const HighlightedArticles: typeof ResolvedStandaloneHighlightedArticles = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneHighlightedArticles {...props} />
    );
});

export type HighlightedArticlesProps = PropsFromComponent<typeof HighlightedArticles>;

/** @deprecated Use slot architecture instead */
export const HighlightedArticlesWith = (extras: DynamicStandaloneExtras): typeof HighlightedArticles => {
    return function HighlightedArticles(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'HighlightedArticles');
        return <ResolvedStandaloneHighlightedArticles {...mergeProps({ options: { theme } }, props)} />;
    }
}